<template>
  <div class="page5">
    <div class="bottom"></div>
    <div class="main">
      <div class="bg"></div>
      <img @click="jump" class="back" src="../../static/img/back.png" alt="" />
      <img class="pic" src="../../static/img/jnsx.png" alt="" />
      <img class="name" src="../../static/img/jnsx-tl.png" alt="" />
      <div class="word">
        <div>
          苏州“鱼米之乡”“人间天堂”的美誉，也与吴淞江流域的繁荣密不可分。
        </div>
        <div>
          千百年来，吴淞江流域不仅历史文化悠久，且贸易兴旺、商业繁荣。在明清时期，苏州更是商业大都会，长江中下游的航运中心。因此，可以说上海的港口地位和文化基因，一定程度上是由吴淞江赋予的。
        </div>
        <div>
          太湖慷慨地向东海输送丰沛的湖水，两地先民之间的沟通，商船的频繁往来，源源不断带去了灿烂的江南文化，让这片处在长江三角洲最前缘的年轻土地，与身后古老的江南水乡血脉相连。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jump() {
      this.$router.push("/page1");
    },
  },
  mounted() {
    let Main = document.querySelector(".main");
    let MainW = Main.getBoundingClientRect().width;
    Main.style.height = (MainW / 750) * 1500 + "px";
  },
};
</script>

<style scoped>
.page5 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.page5 .bottom{
  position:absolute;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background: #89d7c6;
  opacity:0.5;
}
.page5 .main {
  position: absolute;
  left: 0;
  top: -100%;
  bottom: -100%;
  margin: auto;
  width: 100%;
  height: auto;
}
.page5 .bg {
   position: absolute;
  /* width: 50%;
  height: 50%;
  background: url("../../static/img/page2-bg.jpg");
  background-size: 100% 100%;
  top:calc((100vh - 50%) / 2);
  left:calc((100vw - 50%) / 2); 
  animation: bgdh 0.5s ease-out 1;
  animation-fill-mode: forwards; */
   width: 100%;
   height: 100%;
   background: url("../../static/img/page2-bg.jpg");
   background-size: 100% 100%;
   border-radius: 50%;
   transform: scale(0.2);
   animation: bgdh 0.5s linear 1;
   animation-fill-mode: forwards;
}
.back {
  width: 10.13%;
  position: absolute;
  top: 71%;
  left: 10%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.pic {
 width: 52.19%;
  position: absolute;
  top: 13%;
  left: 17%;
  opacity: 0;
  animation: show 2s 1.5s linear 1;
  animation-fill-mode: forwards;
}
.name {
  width: 13.07%;
  position: absolute;
  top: 12%;
  left: 74%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.word {
  width: 67%;
  height: 24%;
  position: absolute;
  left: 16%;
  top: 61%;
  transform:rotateZ(90deg);
  /* background:gray; */
  overflow: auto;
  color: #17848b;
  text-indent: 42px;
  line-height: 28px;
  letter-spacing: 5px;
  opacity: 0;
  animation: show 2s 2s linear 1;
  animation-fill-mode: forwards;
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* @keyframes bgdh {
  0%{
    width: 50%;
    height: 50%;
    border-radius: 50%;
    opacity:0;
    top:calc((100vh - 50%) / 2);
    left:calc((100vw - 50%) / 2);
  }
  100%{
    width: 100%;
    height: 100%;
    border-radius: 0;
    top:0;
    left:0;
    opacity:1;
  }
} */
@keyframes bgdh {
  0%{
    border-radius: 50%;
    transform: scale(0.2)
  }
  100%{
    border-radius: 0 ;
    transform: scale(1)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page5.vue